export const scriptFormConfig = {
    businessPoint: {
        label: '推广业务',
        tip: '推广业务是您提供的最细粒度的产品或服务，例如语言培训客户，业务可能有“雅思培训”托福培训”“少儿英语”等；如果没有合适的，也支持您自定义输入',
        placeholder: '示例：智能音箱',
        maxlength: 50
    },
    brand: {
        label: '品牌/产品名称',
        tip: '需要在营销文案进行品牌传达时可填写；为保障生成文案的有效性，请注意填写品牌/产品与广告账号的匹配状况',
        placeholder: '请填写与投放账号相匹配的品牌',
        maxlength: 30
    },
    description: {
        label: '产品描述',
        tip: '具体的产品描述将会作为AI生成的参考信息，从而使生成的营销文案更贴合您的业务和产品',
        placeholder: '示例：搭载了百度先进的人工智能系统DuerOS，拥有海量有声内容，400多项生活常用技能，可语音控制家中常用家电',
        maxlength: 500,
        rows: 4
    },
    duration: {
        label: '口播时长',
        tip: '可设置期望口播视频时长，时长将会影响文案长度',
        placeholder: '请输入',
        min: 5,
        max: 120
    },
    effectTarget: {
        label: '效果目标',
        tip: '将会基于您选中的效果目标来推荐对应的优质卖点',
        placeholder: '请选择效果目标',
        options: [
            {value: 'CLICK', label: '广告点击'},
            {value: 'APP_INVOKE', label: '应用调起'},
            {value: 'ACTIVE', label: '激活'},
            {value: 'LOGIN', label: '登录（注册激活后登录）'},
            {value: 'FORM', label: '表单（表单提交成功）'},
            {value: 'ORDER', label: '商品下单'},
            {value: 'GOODS_PAY', label: '商品支付'},
            {value: 'FAN', label: '微信加粉'},
            {value: 'READING_PAY', label: '付费阅读'}
        ]
    },
    salePoints: {
        label: '卖点',
        tip: '希望在营销文案中突出的产品卖点信息，最多填写3个',
        placeholder: '示例：操作方便、识音率高'
    },
    targetUser: {
        label: '受众',
        tip: '您可以自定定义描述目标受众特征，从而使生成的营销文案更有针对性'
    },
    style: {
        label: '风格',
        tabs: [
            {label: '预设风格', value: 'preset'},
            {label: '自定义风格', value: 'custom'}
        ],
        options: [
            {label: '不限', value: ''},
            {label: '幽默', value: 'HUMOROUS'},
            {label: '温馨', value: 'WARM'},
            {label: '专业', value: 'SPECIALITY'},
            {label: '励志', value: 'SELF_IMPOVEMENT'},
            {label: '科普', value: 'SCIENCE'}
        ]
    },
    originText: {
        label: '参考文案',
        placeholder: '请输入参考文案',
        maxlength: 1000,
        rows: 4
    },
    additionalInfo: {
        label: '附加说明',
        tip: '您可以通过附加说明来开放式表达您对于生成文案的要求',
        placeholder: '示例：需要包含****，不要包括****\n适用于双十一购物节',
        maxlength: 500,
        rows: 4
    },
    targetCount: {
        tip: 'AI将会尽量生产足够数量的文案，但由于生成文案需要进行审核、质量保障等过滤，偶尔可能会出现少于预期个数的情况，对此您可以尝试多次生成。',
        options: [
            {label: '1', value: '1'},
            {label: '2', value: '2'},
            {label: '3', value: '3'}
        ]
    },
    editMaxlength: 1000
};
